import { render, staticRenderFns } from "./EventWeekTemplateContainer.vue?vue&type=template&id=d2329b1e&"
import script from "./EventWeekTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./EventWeekTemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports